import { useEffect, useState } from 'react';
import { CalendarPlus, PencilSimple, X } from '@phosphor-icons/react';
import { InnenKarte, KartenTitel } from '../../../../components/immobilien/ui';
import { useNutzerId } from '../../../../lib/immobilien/useNutzer';
import TerminFormular from '../../kalender/TerminFormular';
import type { Termin } from '../../kalender/KalenderView';
import { ladeFormularStammdaten } from './formularDaten';

/**
 * Termin anlegen / bearbeiten im neuen Design: das bestehende Termin-Formular (gleiche Logik –
 * Outlook-Abgleich, Teilnehmer, Ticket-Verlauf, Bcc-Anfrage) in der Variante „immo“ direkt auf der Seite.
 * data-immo-ueberlagerung: Escape schließt währenddessen nicht das umgebende Panel.
 */
export function TerminFormularKarte({ termin, prefillDate = null, prefillObjektId = null, prefillTyp = null, prefillTitel = null, prefillMieterId = null, prefillEigentuemerId = null, prefillDienstleisterId = null, ticketId, teamMembers, onAbbrechen, onGespeichert }: {
  termin: Termin | null;
  prefillDate?: string | null;
  prefillObjektId?: string | null;
  prefillTyp?: string | null;
  prefillTitel?: string | null;
  prefillMieterId?: string | null;
  prefillEigentuemerId?: string | null;
  prefillDienstleisterId?: string | null;
  ticketId?: string;
  /** Wenn schon geladen (Kalender); sonst lädt die Karte selbst */
  teamMembers?: { id: string; full_name: string }[];
  onAbbrechen: () => void;
  onGespeichert: () => void;
}) {
  const nutzerId = useNutzerId();
  const [team, setTeam] = useState<{ id: string; full_name: string }[] | null>(teamMembers ?? null);

  useEffect(() => {
    if (teamMembers) { setTeam(teamMembers); return; }
    let aktiv = true;
    ladeFormularStammdaten().then(st => { if (aktiv) setTeam(st.teamMembers); }).catch(() => { if (aktiv) setTeam([]); });
    return () => { aktiv = false; };
  }, [teamMembers]);

  return (
    <div data-immo-ueberlagerung className="immo-side-in">
      <InnenKarte style={{ boxShadow: 'inset 0 0 0 2px var(--acc)' }}>
        <KartenTitel icon={termin ? PencilSimple : CalendarPlus} rechts={
          <button type="button" aria-label="Schließen" onClick={onAbbrechen} className="flex items-center justify-center cursor-pointer"
            style={{ width: 30, height: 30, borderRadius: '50%', border: 'none', background: 'var(--fill2)', color: 'var(--ink)' }}><X size={14} weight="bold" /></button>
        }>{termin ? 'Termin bearbeiten' : 'Neuer Termin'}</KartenTitel>
        {team === null ? <span style={{ fontSize: 13, color: 'var(--ink3)' }}>Formular wird geladen …</span> : (
          <TerminFormular variant="immo" editTermin={termin} prefillDate={prefillDate} prefillObjektId={prefillObjektId} prefillTyp={prefillTyp} prefillTitel={prefillTitel} prefillMieterId={prefillMieterId} prefillEigentuemerId={prefillEigentuemerId} prefillDienstleisterId={prefillDienstleisterId}
            ticketId={ticketId} teamMembers={team} userProfile={nutzerId ? { id: nutzerId } : undefined} onClose={onAbbrechen} onSaved={onGespeichert} />
        )}
      </InnenKarte>
    </div>
  );
}
